import { Switch } from '@headlessui/react';
import { XMarkIcon } from '@heroicons/react/24/outline';
import { CheckIcon } from '@heroicons/react/24/solid';
import cx from 'classnames';

interface Props {
  enabled: boolean;
  onToggle: () => void;
  screenReaderText?: string;
}

const Toggle = ({ enabled = false, onToggle, screenReaderText = 'Use setting' }: Props) => {
  return (
    <Switch
      checked={enabled}
      onChange={onToggle}
      className={cx(
        enabled ? 'bg-wt-primary' : 'bg-gray-200',
        'relative inline-flex h-6 w-11 flex-shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out focus:outline-none focus:ring-2 focus:ring-wt-primary focus:ring-offset-2',
      )}
    >
      <span className="sr-only">{screenReaderText}</span>
      <span
        className={cx(
          enabled ? 'translate-x-5' : 'translate-x-0',
          'pointer-events-none relative inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200 ease-in-out',
        )}
      >
        {enabled ? <CheckIcon className="h-5 w-5 p-1" /> : <XMarkIcon className="h-5 w-5 p-1" />}
      </span>
    </Switch>
  );
};

export default Toggle;
